<div class="dynamic-content" [innerHTML]="innerHtml"></div>
